import { render, staticRenderFns } from "./ConfigurazioniMagazzinoTipoDocumentoListPage.vue?vue&type=template&id=ef5988f0"
import script from "./ConfigurazioniMagazzinoTipoDocumentoListPage.vue?vue&type=script&lang=js"
export * from "./ConfigurazioniMagazzinoTipoDocumentoListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports